// extracted by mini-css-extract-plugin
module.exports = {"login":"LoginButton_login__ihvJD","size-sm":"LoginButton_size-sm__97KUh","size-lg":"LoginButton_size-lg___H9wT"};